export default __webpack_public_path__ + "static/media/password-manager-2.20551f5b.png";